export const REGISTER_SERVICE = "registerServiceMessageBroker";
export const REGISTER_CLIENT = "registerClientMessageBroker";
